import axios from 'axios';
import { variables } from '../Variables';

export const addNewWhiseEventByAccountType = async (clientTokenByAccountType, body) => {
    try {
        let url = "https://api.whise.eu/v1/calendars/create";

        const config = {
            headers: {
                'Authorization': `Bearer ${clientTokenByAccountType}`,
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.post(url, body, config);
        const newWhiseEventId = response.data.calendarId;
        //console.log(newWhiseEventId);
        return newWhiseEventId;
    }
    catch (error) {
        console.log(error);
    }
}

export const getUserAccountType = async (clientId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/CheckAccountType?clientId=${clientId}`;
        const response = await axios.get(url);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

export const getWhiseTokenByUserAccountType = async () => {
    try {
        let url = "https://mink-mtsi-api.net7.be/api/User/GetWhiseTokenPerApp?appName=mtsi";

        let headers = {
            'Content-Type': 'application/json'
        };

        let resp = await axios.post(url, {},
            {
                headers: headers
            });

        if (resp && resp.data && resp.data.token) {
            return resp.data.token;
        }
    }
    catch (e) {
        console.log(e);
    }
}

export const getClientWhiseTokenByUserAccountType = async (clientWhisetoken, clientId, accountType, officeId) => {
    try {
        let url = `https://mink-mtsi-api.net7.be/api/User/GetWhiseClientTokenByAccountTypeForOtherSites?whiseToken=${clientWhisetoken}&clientId=${clientId}&accountType=${accountType}&officeId=${officeId}`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, {}, config);

        if (response.data.token) {
            return response.data.token;
        }
    }
    catch (e) {
        console.log(e);
    }
}

export const createEmailHistoryOnCRM = async (clientTokenBySystemIntegroterAccount, body) => {
    try {
        let url = `https://api.whise.eu/v1/activities/histories/create`;

        const config = {
            headers: {
                'Authorization': `Bearer ${clientTokenBySystemIntegroterAccount}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, body, config);

        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

// add action logs
export const addNewActionsLog = async (body) => {
    try {
        let url = `${variables.API_URL}LocalEvents/LogAction`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, body, config);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}